export default __webpack_public_path__ + "static/media/secure_by_default.28b3d484.svg";